export const API_URL = process.env.NEXT_PUBLIC_API_URL || '';
export const RESIM_URL = process.env.NEXT_PUBLIC_RESIM_URL || '';